export default __webpack_public_path__ + "static/media/instagram.90d8caac.svg";